export default __webpack_public_path__ + "static/media/vegetarian.8d5a5dc6.jpg";